var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplianceApprovedFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dhc2ztqyka",
    d: "M0 0h16.971v22H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.943 5.343h4.117l-4.432-4.4v4.085c-.03.157.095.283.252.315h.063z",
    fill: "#00BE8A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mwzfht3u0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dhc2ztqyka"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.36 11.277-2.101 1.52.807 2.466a.354.354 0 0 1-.127.392.352.352 0 0 1-.413 0L8.43 14.126l-2.095 1.53a.352.352 0 0 1-.543-.38l.003-.013.807-2.466-2.101-1.52a.353.353 0 0 1-.128-.393.35.35 0 0 1 .333-.242h.011l2.583.005.797-2.469a.35.35 0 0 1 .303-.24h.007a.037.037 0 0 1 .008-.002h.015a.35.35 0 0 1 .334.242l.797 2.47 2.593-.006h.002a.35.35 0 0 1 .204.635zM11.943 6.6c-.88 0-1.572-.692-1.572-1.572V0H1.885A1.891 1.891 0 0 0 0 1.886v18.229C0 21.15.849 22 1.885 22h13.2a1.891 1.891 0 0 0 1.886-1.885V6.6h-5.028z",
    fill: "#00BA8D",
    mask: "url(#mwzfht3u0b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceApprovedFile);
export default __webpack_public_path__ + "static/media/compliance-approved-file.d4b40a2a.svg";
export { ForwardRef as ReactComponent };